import React, {useCallback} from 'react';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {userReportAPI} from 'features/userReports/api/userReportAPI';
import {fetchMe} from 'entities/user';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IUserReport from 'features/userReports/model/UserReport/IUserReport';
import {TypedDispatch} from 'shared/model/types';

interface IUserReportDeleteModalProps {
    item: IUserReport,
    open: boolean;
    handleClose: () => void;
}

const UserReportDeleteModal: React.FC<IUserReportDeleteModalProps> = ({item, open, handleClose}) => {
    const [deleteUserReport, {isLoading}] = userReportAPI.useDeleteUserReportMutation();
    const dispatch = useDispatch<TypedDispatch>();

    const onClickDelete = useCallback(async() => {
        const result = await deleteUserReport(item.uuid);
        if ('error' in result) return;
        toast.info(t`Отчёт удалён`);
        dispatch(fetchMe());
        handleClose();
    }, [deleteUserReport, item.uuid, dispatch, handleClose]);

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление отчёта`}
            title={t`Удалить отчёт`}
            name={item.name}
            hint={
                <Trans
                    id="modal.report.delete.text"
                    message="Отчёт больше не будет формироваться. Это действие нельзя отменить."
                />
            }
            confirmText={t`Удалить`}
            onConfirm={onClickDelete}
            isLoading={isLoading}
        />
    );
};

export default UserReportDeleteModal;
